import F from "../../../rc-util/es/KeyCode.mjs";
function e(C) {
  return ![
    // System function button
    F.ESC,
    F.SHIFT,
    F.BACKSPACE,
    F.TAB,
    F.WIN_KEY,
    F.ALT,
    F.META,
    F.WIN_KEY_RIGHT,
    F.CTRL,
    F.SEMICOLON,
    F.EQUALS,
    F.CAPS_LOCK,
    F.CONTEXT_MENU,
    // F1-F12
    F.F1,
    F.F2,
    F.F3,
    F.F4,
    F.F5,
    F.F6,
    F.F7,
    F.F8,
    F.F9,
    F.F10,
    F.F11,
    F.F12
  ].includes(C);
}
export {
  e as isValidateOpenKey
};
//# sourceMappingURL=keyUtil.mjs.map
